import React from 'react';

import { styled } from '@mui/material/styles';
import classnames from 'classnames';


const Container = styled('section')`
  display: flex;
  justify-content: center;

  iframe {
    border: 0;
  }
`;

type Props = {
  className?: string;
};

const Map = ({ className }: Props) => (
  <Container className={classnames('Map', className)}>
    <iframe title='Coastal Ready Mix LLC Map' src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3310.804262186703!2d-79.05386572267123!3d33.92043697320683!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89000c9a908c8af7%3A0x4c867dcfd147254a!2s3470%20Mt%20Pisgah%20Cemetery%20Rd%2C%20Conway%2C%20SC%2029526!5e0!3m2!1sen!2sus!4v1772890174242!5m2!1sen!2sus" width="600" height="450" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>

  </Container>
);

export default Map;